import { V2 } from 'types/swagger/clarifai-api';
import { objectToQueryParams } from 'utils/request/objectToQueryParams';
import { fetch } from 'utils/request';

export const getModel = ({
  params,
  query,
  sessionToken,
}: {
  params: V2.V2GetModel.RequestParams;
  query: V2.V2GetModel.RequestQuery;
  sessionToken?: string;
}) => {
  const queryParams = objectToQueryParams(query);

  return fetch<V2.V2GetModel.ResponseBody>({
    path: `/api/_api/v2/users/${params.userAppIdUserId}/apps/${params.userAppIdAppId}/models/${encodeURIComponent(params.modelId)}${queryParams}`,
    method: 'GET',
    sessionToken,
  });
};
